import * as React from 'react';
export const IcMoon14 = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.95 10.98a9.781 9.781 0 00-.74-2.87c-.21-.49-.46-.94-.73-1.39-.39-.62-.84-1.21-1.35-1.73l-.06-.06-.06-.06c-.52-.51-1.1-.96-1.73-1.35-.44-.28-.9-.53-1.39-.73-.3-.13-.61-.24-.92-.34-.63-.19-1.28-.33-1.95-.4C12.68 2.02 12.34 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10a9.781 9.781 0 002.97-.45c.63-.2 1.23-.45 1.79-.76 1.13-.62 2.13-1.44 2.95-2.43a9.6 9.6 0 001.5-2.47c.51-1.2.79-2.51.79-3.89 0-.35-.02-.69-.05-1.02zM4 12c0-4.41 3.59-8 8-8v16c-4.41 0-8-3.59-8-8z'
      fill='currentColor'
    />
  </svg>
);
